export default __webpack_public_path__ + "static/12-499323bcc42751b6c2dba7a11af3fc4a.jpg";